module.exports = __webpack_public_path__ + "img/effects-12.f93a93cb.png";